import { useEffect } from 'react'
import Swal from 'sweetalert2'
import { CONSTANT } from '../utils/Constants'
import { useTheme } from '@mui/material/styles'
import { t } from 'i18next'

interface MessageTypes {
  type: number
  msg: string
  details?: string
  callback?: () => void
  color: string
}

const MessageManager = ({ type, msg, details, callback, color }: MessageTypes) => {
  useEffect(() => {
    showMessage()
    // eslint-disable-next-line
  }, [])
  const theme = useTheme()

  const showMessage = () => {
    Swal.fire({
      title: `<span style="font-weight: 400">${msg}</span>`,
      text: details,
      icon: type === CONSTANT.ERROR_MSG ? 'error' : 'success',
      confirmButtonText: t('confirm'),
      confirmButtonColor: theme.palette.primary.main,
      focusConfirm: false,

      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
      customClass: {
        confirmButton: 'swal-confirm-button-no-outline'
      },
      didOpen: () => {
        const style = document.createElement('style')
        style.innerHTML = `
          .swal-confirm-button-no-outline:focus {
            box-shadow: none !important;
            outline: none !important;
          }
        `
        document.head.appendChild(style)
      }
    }).then(() => callback && callback())
  }

  return <></>
}

export default MessageManager
